import React, { Fragment } from 'react';

const HourlyRateSF = () => (
  <Fragment>
    <p>Our hourly rate ranges from $7 to $9, and includes:</p>
    <ul>
      <li>Unlimited mileage</li>
      <li>Full maintenance</li>
      <li>Comprehensive insurance</li>
      <li>Roadside assistance</li>
      <li>24/7 Emergency support</li>
    </ul>
    <br />
  </Fragment>
);

export default HourlyRateSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/HourlyRateSF.js